<script>
    import { onMount, createEventDispatcher } from 'svelte';
    import { fade } from 'svelte/transition';
    import { getServer } from '../shared/utils/Data.svelte'
    import { save, refresh, addCircleOutline } from 'ionicons/icons/index.mjs';
    export let session;
    export let content;
    let viewer; 
    const dispatch = createEventDispatcher();
    onMount(() => {
        var iframe = document.getElementById("viewer");
        iframe.src = getServer() + "/apps/scene/viewer";
    });
    function loadHandler() {
        viewer = document.getElementById("viewer").contentWindow;
        var message = {
            type: "init",
            sceneId: content.id,
            token: session.token
        };
        viewer.postMessage(JSON.stringify(message), "*");
    }
    function sceneEventHandler(e, type) {
        e.currentTarget.blur();
        var message = {
            type: type
        };
        viewer.postMessage(JSON.stringify(message), "*");
    }
    function sendMessage(message) {
		dispatch('message', message);
    }
</script>

<div id="stage" in:fade>
    <iframe id="viewer" on:load={loadHandler} title="Scene Viewer" />
</div>

<style>
    #stage {
        overflow: hidden;
        width: 100%;
        height: 100vh;
    }
    #viewer {
        width: 100%;
        height: 100vh;
        border: 0;
    }
</style>